/**
 * Swym Wishlist - Cart Update Integration
 * Syncs cart counter when items are added via Swym wishlist buttons
 */
(function() {
  document.addEventListener('click', function(e) {
    const swymBtn = e.target.closest('.swym-storefront-layout-grid-item-add-to-cart-button, [data-action="add-to-cart"]');
    if (!swymBtn) return;

    // Wait for Swym to process the add to cart
    setTimeout(async function() {
      try {
        // Fetch updated cart data
        const response = await fetch('/cart.js');
        const cartData = await response.json();

        // Dispatch cart update events
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              itemCount: cartData.item_count,
              source: 'swym-wishlist'
            }
          }
        }));

        document.dispatchEvent(new CustomEvent('cart:updated'));

        // Update cart bubble/counter directly
        const cartBubbles = document.querySelectorAll('.cart-bubble');
        cartBubbles.forEach(bubble => {
          bubble.textContent = cartData.item_count;
          if (cartData.item_count > 0) {
            bubble.style.display = '';
          }
        });

      } catch (error) {
        console.error('Error updating cart after Swym add:', error);
      }
    }, 1000);
  });
})();
